import { useMemo } from "react";
import { getPortfolioReportingSummaryQuery } from "web_myplann/Api/Portfolio/Queries/getPortfolioReportingSummaryQuery";
import { usePortfolioListQuery } from "web_myplann/Api/Portfolio/Queries/usePortfolioListQuery";
import { usePropertyListQuery } from "web_myplann/Api/Portfolio/Queries/usePropertyListQuery";
import {
	ClientPortfolioDomainEnum,
	type PortfolioReportingOverviewTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { REPORTING_VALUE_DOMAINS } from "web_myplann/Portfolio/Helpers/portfolioReportingDomains";

export const useDashboardDetailData = (
	overviewType: PortfolioReportingOverviewTypeEnum | undefined,
) => {
	const filterDatagroups = overviewType ? [overviewType] : undefined;
	const { data: portfolios, isLoading: isPortfoliosLoading } =
		usePortfolioListQuery(filterDatagroups, true, !!overviewType);
	const { data: properties, isLoading: isPropertiesLoading } =
		usePropertyListQuery(filterDatagroups, true, !!overviewType);

	const specialPortfolioListIds = useMemo(() => {
		if (!portfolios?.data) return [];
		return portfolios.data
			.filter(
				(p) =>
					p.domain !== undefined &&
					p.domain !== null &&
					(REPORTING_VALUE_DOMAINS.includes(p.domain) ||
						p.domain === ClientPortfolioDomainEnum.LifeInsurance),
			)
			.map((p) => p.id);
	}, [portfolios?.data]);

	const { data: reporting } = getPortfolioReportingSummaryQuery(
		specialPortfolioListIds,
		filterDatagroups,
	);

	const hasData = !!(portfolios?.data || properties?.data);
	const isLoading = (isPortfoliosLoading || isPropertiesLoading) && !hasData;

	return {
		portfolios,
		properties,
		reporting,
		isLoading,
	};
};
